import { environment } from "src/environments/environment";
import { BrandModel } from "./models/brand.model";
import { UserModel } from "./models/user.model";
import { partialInit } from "./utils/partial-init";
import { PlanModel } from "./models/plan.model";

export class ContextType {
  authToken: string | null;
  user: UserModel | null;
  endpoint: string;
  brand: BrandModel;
  plan: PlanModel | null;
  reset: () => void;

  constructor(data?: Partial<ContextType>) {
    partialInit(this, data);
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Context = new ContextType({
  authToken: null,
  user: null,
  brand: <any>null,
  plan: null,
  endpoint: environment.baseUrl,
  reset: function () {
    Context.authToken = null;
    Context.user = null;
    Context.plan = null;
  }
});
